import React from 'react'
import { StyleConversationWrapper } from './style'
import ConversationLayout from './header'

const Conversations = () => {
  return (
    <StyleConversationWrapper>
      <ConversationLayout />
    </StyleConversationWrapper>
  )
}

export default Conversations
